import { fetchJSON } from "./utils";
import { formatInTimeZone } from "../utils/dates.js";

const TASK_TYPES = {
    CREATE_INTERACTION: "create-interaction",
    CLASSIFY_INTERACTION: "classify-interaction",
    CLOSE_INTERACTION: "close-interaction",
    NOTIFY_UNRESPONDED_SUMMARY: "notify-unresponded-summary",
    SOFT_ALERT: "soft-alert",
    FOLLOW_UP: "follow-up",
    NOTIFY_TICKET_CLOSE: "notify-ticket-close",
    NOTIFY_UNRESPONDED_TICKET: "notify-unresponded-ticket",
    NOTIFY_UNRESPONDED_ALERT: "notify-unresponded-alert",
    VA_SURVEY: "va-survey",
};
const taskLabels = {
    "create-interaction": "Creating interaction",
    "classify-interaction": "Classifying interaction",
    "close-interaction": "VA Closing interaction",
    "notify-unresponded-summary": "Weekly unresponded summary email",
    "soft-alert": "Will turn the interaction into a soft alert",
    "follow-up": "Will follow up with the user",
    "notify-ticket-close": "Will trigger the ticket close flow",
    "notify-unresponded-ticket": "24h email alert for unresponded ticket",
    "notify-unresponded-alert": "24h email alert for unresponded soft alert",
    "va-survey": "Weekly VA survey",
};


function formatTask(task) {
    let formattedTask = {
        task_id: task.task_id,
        label: taskLabels[task.task_type] || task.task_type,
        task_type: task.task_type,
        task_date: task.task_date,
        task_errors: task.errors,
        formatted_task_date: formatInTimeZone(task.task_date),
    };
    if (task.task_object) {
        if (task.task_type === TASK_TYPES.CREATE_INTERACTION) {
            // here task_object is an RTB interaction object
            formattedTask.interaction_id = task.task_object.interaction?.interaction_id;
            formattedTask.query = task.task_object.interaction?.query;
            formattedTask.company_code = task.task_object.interaction?.company_id;
            formattedTask.interaction_created_at = formatInTimeZone(task.task_object.interaction?.created_at);
            formattedTask.user_id = task.task_object.interaction?.user_id;
            formattedTask.username = task.interaction.interaction?.username
        }

        else if ([
            TASK_TYPES.CLASSIFY_INTERACTION,
            TASK_TYPES.FOLLOW_UP,
            TASK_TYPES.SOFT_ALERT,
            TASK_TYPES.CLOSE_INTERACTION].includes(task.task_type)
        ) {
            // here task_object is an interaction2 object
            formattedTask.interaction_id = task.task_object.interaction_id;
            formattedTask.query = task.task_object.query;
            formattedTask.company_code = task.task_object.company_code;
            formattedTask.interaction_created_at = formatInTimeZone(task.task_object.createdAt);
        }
    }
    if (task.user) {
        formattedTask.username = task.user.username
        formattedTask.user_id = task.user.id;
    }

    return formattedTask;
}


export async function fetchQueuedTasks() {
    const url = "/api/admin/tasks";
    const tasksResponse = await fetchJSON(url, null, null, "get");
    console.log(tasksResponse);

    return tasksResponse.data.map(formatTask);
}


export async function deleteTask(taskId) {
    const url = "/api/admin/tasks/cancel";
    return fetchJSON(url, { task_id: taskId }, null, "get");
}

export async function fetchSummaries(filter) {
    const url = "/api/admin/dsat_summary";

    const resp = await fetchJSON(url, filter, null, "get");
    return resp.data;
}